<template>
  <div class="col-12 mb-primary">
    <div class="card card-with-shadow border-0 h-100">
      <app-overlay-loader v-if="preloader" />
      <div class="card-body">
        <div class="row">
          <div class="col-6">
            <div class="row">
              <div class="col-md-12 col-12">
                <label for="text_input">
                  {{ $t("title") }}
                </label>
                <app-input
                  id="text_title"
                  type="text"
                  :read-only="true"
                  v-model="inputs.title"
                />
              </div>
              <div class="col-md-12 col-12">
                <label for="text_input">
                  {{ $t("taskcategory") }}
                </label>
                <app-input
                  id="text_taskcategory"
                  type="text"
                  :read-only="true"
                  v-model="inputs.select_task_category"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label for="text_input">
                  {{ $t("start_date") }}
                </label>
                <app-input
                  id="start_date"
                  type="text"
                  :read-only="true"
                  v-model="inputs.start_date"
                />
              </div>
              <div class="col-md-6">
                <label for="text_input">
                  {{ $t("due_date") }}
                </label>
                <app-input
                  id="due_date"
                  type="text"
                  :read-only="true"
                  v-model="inputs.due_date"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label for="text_input">
                  {{ $t("priority") }}
                </label>
                <app-input
                  id="priority"
                  type="text"
                  :read-only="true"
                  v-model="inputs.priority"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label for="text_input">
                  {{ $t("description") }}
                </label>
                <app-input
                  id="description"
                  type="textarea"
                  :read-only="true"
                  v-model="inputs.description"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label for="text_input">
                  {{ $t("fiels") }}
                </label>
                <div class="row">
                  <div
                    class="col-sm-12 col-md-12 mb-3"
                    v-for="(file, index) in taskFiles"
                    :key="index"
                  >
                    <a :href="file.filename" download>
                      <app-widget
                        v-if="
                          file.extention == 'pdf' ||
                          file.extention == 'xls' ||
                          file.extention == 'doc'
                        "
                        class="mb-primary"
                        :type="'app-widget-with-icon'"
                        :label="file.filename"
                        :icon="'file-text'"
                      />

                      <app-widget
                        v-else
                        class="mb-primary"
                        :type="'app-widget-with-icon'"
                        :label="file.filename"
                        :icon="'image'"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <button
                  type="button"
                  class="btn btn-primary mr-2 mt-2"
                  data-dismiss="modal"
                  @click="submit"
                >
                  {{ $t("update") }}
                </button>
              </div>
            </div>
          </div>

          <div class="col-6">
            <div class="row">
              <div class="col-md-12 col-12">
                <comments-view :comments="comments" :id="this.inputs.id" />
              </div>
            </div>
          </div>
        </div>

        <!-- data table Start here -->
        <div class="mt-4">
          <app-table :id="tableId" :options="options" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ModalMixin } from "../../../../../../app/Mixins/ModalMixin";
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin.js";
import {
  DEPENDENT_TASK,
  TASK_LISTING,
  UPDATE_MY_TASK,
  MY_TASK_SHOW,
} from "../../../../../Config/ApiUrl";
import {
  axiosPost,
  axiosGet,
  axiosPatch,
} from "../../../../../Helpers/AxiosHelper";
import { TableHelpers } from "../../../Demo/Tables/mixins/TableHelpers";
import CoreLibrary from "../../../../../../core/helpers/CoreLibrary.js";

export default {
  extends: CoreLibrary,
  name: "DatatableWithFilter",
  mixins: [TableHelpers],
  name: "mytaskmodal",
  mixins: [ModalMixin, FormMixin],
  // props: {
  //   tableId: String,
  //   id: Number,
  // },
  data() {
    return {
      taskFiles: [],
      inputs: {},
      comments: {},
      statusList: [
        { id: "incomplete", value: "Incomplete" },
        { id: "completed", value: "Completed" },
      ],
      test: false,
      tabledata: [],
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      selectedUrl: "",
      tableId: "advance-table",
      rowData: {},
      options: {
        name: "AdvanceTable",
        url: DEPENDENT_TASK + "/" + this.id,
        // url: actions.DATATABLE_DATA,
        showHeader: false,
        columns: [
          {
            title: this.$t("task"),
            type: "custom-html",
            key: "title",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          // {
          //     title: this.$t('assigned_to'),
          //     type: 'custom-html',
          //     key: 'assigned_to',
          //     modifier: (value) => {
          //         return `<span>${this.$t(value)}</span>`
          //     }
          // },
          {
            title: this.$t("start_date"),
            type: "custom-html",
            key: "start_date",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("due_date"),
            type: "custom-html",
            key: "due_date",
            modifier: (value) => {
              var result = '';
              let ClassName = "warning";

              const moment = require('moment');
              // Define your due date and current date
              const dueDate = moment(value+' 23:59:59'); // Replace with your due date
              const currentDate = moment(); // Current date and time

              // Calculate the difference in time
              const timeDiff = dueDate.diff(currentDate);
              if (timeDiff > 0) {
                const duration = moment.duration(timeDiff);
                if (duration.days() > 0) {
                  result = `${duration.days()} day${duration.days() > 1 ? 's' : ''} left`;
                  if(duration.days() > 30) {
                    ClassName = 'success';
                  }
                } else if (duration.hours() > 0) {
                  result = `${duration.hours()} hour${duration.hours() > 1 ? 's' : ''} left`;
                } else {
                  result = `${duration.minutes()} minute${duration.minutes() > 1 ? 's' : ''} left`;
                }
              } else {
                  result = 'The due date has passed.';
                  ClassName = 'danger';
              }
              // return `<span>${this.$t(result)}</span>`;
              return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                result
              )}</span>`;
            },
          },
          {
            title: this.$t("priority"),
            type: "custom-html",
            key: "priority",
            modifier: (value) => {
              let ClassName = "danger";

              if (value === "low") ClassName = `success`;
              else if (value === "medium") ClassName = `warning`;
              else if (value === "high") ClassName = `danger`;
              return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                value
              )}</span>`;
            },
          },
          {
            title: this.$t("status"),
            type: "custom-html",
            key: "status",
            isVisible: true,
            modifier: (value) => {
              let ClassName = "danger";

              if (value === "completed") ClassName = `success`;
              else if (value === "incomplete") ClassName = `warning`;

              return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                value
              )}</span>`;
            },
          },
        ],
        actions: [],
        showFilter: false,
        showSearch: false,
        showCount: false,
        showClearFilter: false,
        // paginationType: "pagination",
        // responsive: true,
        // rowLimit: 10,
        // showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
    };
  },

  methods: {
    submit() {
      let tableid = this.$attrs["props"];
      axiosPatch(UPDATE_MY_TASK, this.inputs)
        .then((res) => {
          this.$toastr.s(res.data.message);
          this.$hub.$emit("reload-" + tableid.tableId);
        })
        .catch((error) => {
          this.$toastr.e(error.data.message);
        });
      // this.save(this.inputs);
    },
    afterSuccess(response) {
      this.$toastr.e(response.data.message);
      this.$hub.$emit("reload-" + tableid.tableId);
    },

    // afterSuccessFromGetEditData(response) {
    //   // if (response.data.phone) this.phone = response.data.phone;
    //   this.inputs = response.data;
    //   this.comments = response.data.comments;
    //   
    //   this.preloader = false;
    // },
    getTask() {
      let id = this.$attrs["props"];
      axiosGet(MY_TASK_SHOW + "/" + id.id)
        .then((response) => {
          this.inputs = response.data.task[0];
          this.inputs.select_task_category = response.data.task[0].category.category_name;
          
          this.comments = response.data.comments;
          this.taskFiles = response.data.task[0].taskfiles;
          
          let documents = response.data.documents;
          this.$store.dispatch("setValueToPass", documents);
          this.preloader = false;
        })
        .catch((error) => {
          
        });
    },
    searchAndSelectFilterOptions() {
      this.axiosGet(actions.DATATABLE_SEARCH_SELECT).then((response) => {
        let name = this.options.filters.find(
          (element) => element.title === this.$t("search_and_select")
        );

        name.option = response.data.map((name) => {
          return {
            id: name.name,
            value: name.name,
          };
        });
      });
    },
  },
  mounted() {
    this.getTask();
  },
};
</script>
